import { connect } from 'react-redux';
import { getHasCommentedOnDeviation } from '../../../../redux/deviations/selectors';
var mapStateToProps = function (state, _a) {
    var deviation = _a.deviation;
    return ({
        hasCommentedOn: getHasCommentedOnDeviation(state, deviation),
    });
};
var mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=CommentControl.container.js.map